jQuery(document).ready(function($) {
   	// Start marquee
     if ($(window).width() < 580){
       if($('.marquee_text').length > 0){
          $('.marquee_text').marquee({
          direction: 'left',
          duration: 15000,
          gap: 15,
          delayBeforeStart: 0,
          duplicated: true,
          startVisible: true
          });
       }
     }

    /*if ($(window).width() > 960){ 
        $("header").hover(function() {
        $(this).toggleClass("hover-effect");
      });
    }*/
    //Header Search Icon
    if($('.header__icon-touch--search').length > 0){
      $('.header__icon-touch--search').click(function() {
        $('.search-bar').slideToggle();
      });
     }
  
    if($('.mobile_search').length > 0){
      $('.mobile_search').click(function() {
        $('.mobile-search-bar').slideToggle();
      });
    }
    
    if($('a#unmute').length > 0){
      $(document).on('click', 'a#unmute', function() {
        var video = document.getElementById("hero-video");
        var volumeIcon = document.querySelector('.icon-button-volume');
        var muteIcon = document.querySelector('.icon-button-volume-mute');
        if (video.muted) {
            video.muted = false;
            volumeIcon.style.display = 'none';
            muteIcon.style.display = 'block';
        } else {
            video.muted = true;
            volumeIcon.style.display = 'block';
            muteIcon.style.display = 'none';
        }
      });
    }
     
    if($('.scroll-to-widget').length > 0){
      $('.scroll-to-widget').on('click', function(event) {
        event.preventDefault();
        var target = $('[data-oke-widget]');
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000);
      });  
    }
    if($('.down-arrow a#down').length > 0){
      $(".down-arrow a#down").on("click", function(event) {
          event.preventDefault();
          var announcementHeight = $(".announcement-bar-outer").outerHeight();
          var headerHeight = $(".header__inner").outerHeight();
          var totalHeight = announcementHeight + headerHeight;
            $('html, body').animate({
                scrollTop: $(".collection-section .collection-banner").offset().top - totalHeight
            }, 1000);
      });
    }

    if($('.product-item').length > 0){
     $('body').on('click', '.product-item .colour_variant label', function() {
        var handle = $(this).parent().find('input').attr('data-handle');
        var current_ele = $(this).closest('.product-item');
        var productItemContainer = current_ele.closest('.product-item__container');
        var colorOptions = current_ele.find('.colour_variant li');
        $.ajax({
            url: '/products/' + handle + '?view=alternate',
            type: 'GET',
            success: function(data) {
                var newContent = $(data).find('.product-item').html();
                current_ele.html(newContent);
                
                var newHandle = productItemContainer.find('.colour_variant input[checked]').attr('data-handle');                  
                productItemContainer.find('.colour_variant ul').empty();
                colorOptions.each((index, el) => {
                  var $el = $(el);
                  productItemContainer.find('.colour_variant ul').append($el);
                });
                
                productItemContainer.find('.colour_variant input').each((index, el) => {
                  $(el).removeAttr('checked');
                  $(el).siblings().css('border', 'none');
                });
                productItemContainer.find('.colour_variant input').each((index, el) => {
                  if ($(el).data('handle') == newHandle) {
                    $(el).attr('checked', 'checked');
                    $(el).siblings().css('border', '1px solid #431C28');                
                  }
                });
            }
        });
    });
    $('.product-item').hover(
      function() {
          $(this).find('.product-item__image--two').toggleClass('active');
      });
    }
    
    if($('.owl-carousel').length > 0){
      var owl = $('.owl-carousel');
      owl.owlCarousel({
        items: 2,
        loop: true,
        margin: 10,
        autoplay: true,
        autoplayTimeout: 35000,        
      });
    }

    var viewportWidth = $(window).width();
    if (viewportWidth <= 768) {
        $('.mobileDiv').show();
    } else {
       $('.desktopDiv').show();
    } 
   
    if($('.product-item__media--multiple-images').length > 0){
      $(document).on('mouseenter', '.product-item__media--multiple-images', function() {
          $(this).addClass('active');
          $(this).find('.product-item__image--two').removeClass('active');
      }).on('mouseleave', '.product-item__media--multiple-images', function() {
          $(this).removeClass('active');
          $(this).find('.product-item__image--two').removeClass('active');
      });
    }
    // Cache the header and hero section elements
    var $header = $('header');
    var $heroSection = $('.hero-section');
    var headerHeight = 112;

    // Function to check scroll position and update header class
    if($('.hero-section').length > 0){
      function checkScroll() {
          var heroBottom = $heroSection.offset().top + $heroSection.outerHeight();
          if ($(window).scrollTop() > heroBottom - headerHeight) {
              $header.addClass('is-sticky');
          } else {
              $header.removeClass('is-sticky');
          }
      }
      // Bind the checkScroll function to the scroll event
      $(window).on('scroll', checkScroll);
      // Run the checkScroll function on page load
      checkScroll();
     }

    if ($('.template-collection .product-item').length > 0) {
        $('.product-item .product-item__text h4').matchHeight({
            property: 'min-height'
        });
    }

    $('.filter-bar__inner').on('click', function() {
        $(this).toggleClass('fullwidth');
    });
    
    /*mobile deskop class toggle*/
    function handleElementRemoval() {
        var isMobile = window.innerWidth <= 960;
        if (isMobile) {
            $('.desktop-video').remove();
            $('.desktop').remove();
        } else {
            $('.mobile-video').remove();
            $('.mobile').remove();
        }
    }
    handleElementRemoval();
    $(window).on('resize', function() {
        handleElementRemoval();
    });
  /* video play/pause on scroll */
  if($('#hero-video').length > 0){
    var video = $('#hero-video').get(0);
    $(window).on('scroll', function() {
        var videoTop = $('.hero-area, .collection-hero').offset().top;
        var videoBottom = videoTop + $('.hero-area, .collection-hero').height();
        var scrollPos = $(window).scrollTop();
        var windowBottom = scrollPos + $(window).height();
        if (windowBottom > videoTop && scrollPos < videoBottom) {
            video.play();
        } else {
            video.pause();
        }
    });
  }
});
